import { useCallback } from 'react';

import { useAtom, useSetAtom } from 'jotai';

import { folderPathAtom } from '../store/fileSystem.js';
import { isKnowledgeBaseOpenAtom } from '../store/knowledgeBase.js';

export const useKnowledgeBase = () => {
  const [isOpen, setIsOpen] = useAtom(isKnowledgeBaseOpenAtom);
  const setFolderPath = useSetAtom(folderPathAtom);

  const resetFolderPath = useCallback(() => {
    setFolderPath([]);
  }, [setFolderPath]);

  const toggle = useCallback(() => {
    if (isOpen) resetFolderPath();

    setIsOpen((prev) => !prev);
  }, [isOpen, setIsOpen, resetFolderPath]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const close = useCallback(() => {
    resetFolderPath();
    setIsOpen(false);
  }, [setIsOpen, resetFolderPath]);

  return { isOpen, toggle, open, close };
};
